import { Flex, Radio } from "@chakra-ui/react";
import { Subtitle } from "src/atoms/typography";

function RadioItem({ label, checked, onChange }) {
  return (
    <Flex my="8px" alignItems="center" onClick={onChange}>
      <Radio isChecked={checked} />
      <Subtitle ml="14px" color="highEmphasis">
        {label}
      </Subtitle>
    </Flex>
  );
}

export default RadioItem;
